function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
function Generic(tp,pred,d){const f=(...args)=>{const t={description:d||'generic',__runtimeType:true,check:v=>pred(v,...args)};return t};f.__runtimeType=true;f.description=d;return f};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {Type,Generic};
/* tjs <- metadata.ts */

/*#
# metadata

## `tosiAccessor(x: any): TosiAccessor | undefined`

`tosiAccessor` returns the collision-free accessor object from any boxed proxy,
using the `TOSI_ACCESSOR` symbol internally. Returns `undefined` for non-proxy values.

This is the guaranteed escape hatch — it works even if your data has a property
named `tosi` that would shadow the `.tosi` convenience accessor.

```
import { tosiAccessor, TOSI_ACCESSOR } from 'tosijs'

const { app } = tosi({ app: { tosi: 'shadowed!', name: 'test' } })

// .tosi is always intercepted by the proxy (not shadowed in practice)
app.tosi.path === 'app'

// tosiAccessor() and TOSI_ACCESSOR are guaranteed collision-free
const acc = tosiAccessor(app)
acc.path === 'app'
acc.value  // { tosi: 'shadowed!', name: 'test' }

// TOSI_ACCESSOR symbol works directly
app[TOSI_ACCESSOR].path === 'app'

// returns undefined for non-proxy values
tosiAccessor('hello') === undefined
tosiAccessor({ foo: 1 }) === undefined
```

## `xinValue(x: any): any` (deprecated)

`xinValue` strips the `xin` or `boxed` proxy off of a value.
Passes through non-proxy values unchanged. Prefer `.value` or `.tosi.value`.

```
import { boxed } from 'tosijs'

const foo = { bar: 'hello', baz: 17 }
boxed.foo = foo

boxed.foo.bar === foo.bar               // false, boxed.foo.bar is a proxy
boxed.foo === foo                       // false, boxed.foo is a proxy
boxed.foo.baz === 17                    // false, boxed.foo.baz is a proxy
boxed.foo.bar.value === 'hello'         // true (preferred)
xinValue(boxed.foo.bar) === 'hello'     // true
boxed.foo.baz.value === 17              // true
xinValue(boxed.foo) === xinValue(foo)   // true
foo.xinValue                            // undefined! foo isn't a proxy
```

## `xinPath(x: any): string | undefined` (deprecated)

`xinPath` returns the path of a `xin` or `boxed` proxy. Returns `undefined`
for non-proxy values. Prefer `.path` or `.tosi.path`.
*/

import { XinObject, XinProps, XinBinding, XinEventHandler, Unboxed } from './xin-types'

import { deepClone } from './deep-clone'

export const BOUND_CLASS = '-xin-data';

export const BOUND_SELECTOR = `.${BOUND_CLASS}`;

export const EVENT_CLASS = '-xin-event';

export const EVENT_SELECTOR = `.${EVENT_CLASS}`;

export const XIN_PATH = Symbol.for('xin-path');

export const XIN_VALUE = Symbol.for('xin-value');

export const XIN_OBSERVE = 'xinObserve';

export const XIN_BIND = 'xinBind';

export const XIN_ON = 'xinOn';

export const TOSI_ACCESSOR = Symbol.for('tosi-accessor');

export const TAKE_DESCRIPTOR = Symbol.for('tosi-take');

export const LIST_BINDING_REF = Symbol('list-binding');

export const LIST_INSTANCE_REF = Symbol('list-instance');

const arrayIdPathRegistry = new Map();

/* line 96 */
export function registerArrayIdPath(arrayPath,idPath) {
    let idPaths = arrayIdPathRegistry.get(arrayPath);
    if (idPaths === undefined) {
        idPaths = new Set();
        arrayIdPathRegistry.set(arrayPath, idPaths);
    }
    idPaths.add(idPath);
}
registerArrayIdPath.__tjs = {
  "params": {
    "arrayPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "metadata.ts:95"
}

/* line 108 */
export function getArrayIdPaths(arrayPath) {
    return arrayIdPathRegistry.get(arrayPath);
}
getArrayIdPaths.__tjs = {
  "params": {
    "arrayPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "metadata.ts:105"
}

/* line 115 */
export function unregisterArrayIdPath(arrayPath,idPath) {
    const idPaths = arrayIdPathRegistry.get(arrayPath);
    if (idPaths !== undefined) {
        idPaths.delete(idPath);
        if (idPaths.size === 0) {
            arrayIdPathRegistry.delete(arrayPath);
        }
    }
}
unregisterArrayIdPath.__tjs = {
  "params": {
    "arrayPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "metadata.ts:110"
}

/* line 128 */
export function _getArrayIdPathRegistry() {
    return arrayIdPathRegistry;
}
_getArrayIdPathRegistry.__tjs = {
  "params": {},
  "unsafe": true,
  "source": "metadata.ts:121"
}

const deprecationWarnings = new Set();

/* line 138 */
export function warnDeprecated(key,message) {
    if (!deprecationWarnings.has(key)) {
        console.warn(message);
        deprecationWarnings.add(key);
    }
}
warnDeprecated.__tjs = {
  "params": {
    "key": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "message": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "metadata.ts:128"
}

/* line 148 */
export function _resetDeprecationWarnings() {
    deprecationWarnings.clear();
}
_resetDeprecationWarnings.__tjs = {
  "params": {},
  "unsafe": true,
  "source": "metadata.ts:136"
}

/* line 155 */
export function deprecated(fn,message = '') {
    let warned = false;
    return ((...args) => {
        if (!warned) {
            console.warn(message);
            warned = true;
        }
        return fn(...args);
    });
}
deprecated.__tjs = {
  "params": {
    "fn": {
      "type": {
        "kind": "any"
      },
      "required": true,
      "default": null
    },
    "message": {
      "type": {
        "kind": "string"
      },
      "required": false,
      "default": ""
    }
  },
  "unsafe": true,
  "source": "metadata.ts:141"
}

/* line 173 */
export function tosiPath(x) {
    return (x && x[XIN_PATH]) || undefined;
}
tosiPath.__tjs = {
  "params": {
    "x": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "returns": {
    "type": {
      "kind": "union",
      "members": [
        {
          "kind": "string"
        },
        {
          "kind": "undefined"
        }
      ]
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "metadata.ts:153"
}

/* line 181 */
/* TODO: TS types degraded — x: T, return: Unboxed<T> */
export function tosiValue(x) {
    if (typeof x === 'object' && x !== null) {
        const val = x[XIN_VALUE];
        return (val !== undefined ? val : x);
    }
    return x;
}
tosiValue.__tjs = {
  "params": {
    "x": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "metadata.ts:159"
}

/* line 194 */
/* TODO: TS types degraded — return: any | undefined */
export function tosiAccessor(x) {
    return x != null ? x[TOSI_ACCESSOR] : undefined;
}
tosiAccessor.__tjs = {
  "params": {
    "x": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "metadata.ts:169"
}

/* line 202 */
/* TODO: TS types degraded — value: T */
export function tosiSetValue(proxy, value) {
    const path = tosiPath(proxy);
    if (path === undefined) {
        throw new Error('tosiSetValue requires a xin or boxed proxy');
    }
    proxy[XIN_VALUE] = value;
}
tosiSetValue.__tjs = {
  "params": {
    "proxy": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "value": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "metadata.ts:175"
}

export const xinPath = deprecated(tosiPath, 'xinPath is deprecated. Use tosiPath instead.');

export const xinValue = deprecated(tosiValue, 'xinValue is deprecated. Use tosiValue instead.');

export const DataBinding = Generic([['T', {}]], (() => {let __f = 0;const __fuel = () => { if (--__f < 0) throw new RangeError('tjs:predicate-fuel'); };function __pred_DataBinding(x, checkT) {__fuel(); return typeof x === 'object' && x !== null && 'path' in x && 'binding' in x && 'options' in x }return (...__a) => {__f = 1000000;try { return !!__pred_DataBinding(...__a); }catch (e) {if (e instanceof RangeError && /tjs:predicate-fuel|stack/i.test(e.message)) return false;throw e;}};})(), 'DataBinding')

export const DataBindings = Type('DataBindings', undefined, [null])

export const XinEventBindings = Type('XinEventBindings')

export const elementToHandlers = new WeakMap();

export const elementToBindings = new WeakMap();

const ElementMetadata = Type('ElementMetadata', undefined, { eventBindings: null, dataBindings: null })

/* line 243 */
export function getElementBindings(element) {
    return {
        eventBindings: elementToHandlers.get(element),
        dataBindings: elementToBindings.get(element),
    };
}
getElementBindings.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "object",
      "shape": {
        "eventBindings": {
          "kind": "object",
          "shape": {}
        },
        "dataBindings": {
          "kind": "array",
          "items": {
            "kind": "null"
          }
        }
      }
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "metadata.ts:200"
}

/* line 250 */
export function cloneWithBindings(element) {
    const cloned = element.cloneNode();
    if (cloned instanceof Element) {
        const dataBindings = elementToBindings.get(element);
        const eventHandlers = elementToHandlers.get(element);
        if (dataBindings != null) {
                                                                 
            elementToBindings.set(cloned, deepClone(dataBindings));
        }
        if (eventHandlers != null) {
                                                                 
            elementToHandlers.set(cloned, deepClone(eventHandlers));
        }
    }
    for (const node of Array.from(element instanceof HTMLTemplateElement
        ? element.content.childNodes
        : element.childNodes)) {
        if (node instanceof Element || node instanceof DocumentFragment) {
            cloned.appendChild(cloneWithBindings(node));
        }
        else {
            cloned.appendChild(node.cloneNode());
        }
    }
    return cloned;
}
cloneWithBindings.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "object",
      "shape": {}
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "metadata.ts:208"
}